/**
 * Regola "non letta" delle conversazioni Instagram e Messenger (logica pura, testata).
 *
 * Una conversazione e' non letta quando l'ultimo messaggio del contatto e' piu' recente
 * dell'ultima lettura. Se pero' l'ultimo messaggio e' nostro ed e' piu' recente di quello
 * del contatto (per esempio una risposta data dall'app di Meta, fuori dal CRM), la
 * conversazione ha gia' avuto risposta e non conta come non letta.
 */
export interface MetaUnreadFields {
  last_inbound_at?: string | null;
  last_message_direction?: 'inbound' | 'outbound' | null;
  last_message_preview_at?: string | null;
}

function toTime(value: string | null | undefined): number {
  if (!value) return 0;
  const t = new Date(value).getTime();
  return Number.isFinite(t) ? t : 0;
}

export function isMetaConversationUnread(conversation: MetaUnreadFields, lastReadAt: string | null | undefined): boolean {
  const inbound = toTime(conversation.last_inbound_at);
  if (!inbound) return false;
  const ourLatest = conversation.last_message_direction === 'outbound' ? toTime(conversation.last_message_preview_at) : 0;
  if (ourLatest > inbound) return false;
  const read = toTime(lastReadAt);
  if (!read) return true;
  return inbound > read;
}
